import SlickArrow from "@components/SearchManagement/SlickArrow";
import { useMemo } from "react";
// Link to React-Magic-Slider-Dots library https://github.com/patricktran/react-magic-slider-dots
// Library is copied into the project because it is small one, we don't expect it to have any changes, and also to have less package dependencies in the project and we don't expect it to have any changes;

interface deviceSettings {
  class?: string;
  dots?: boolean;
  arrows?: boolean;
  infinite?: boolean;
  slidesToShow?: number;
  slidesToScroll?: number;
  variableWidth?: boolean;
}

interface Iarrows {
  offset: string;
  color: string;
}

interface Isettings {
  isFullWidth?: boolean;
  arrows?: Iarrows;
  desktop?: deviceSettings;
  mobile?: deviceSettings;
  disableLazyLoad?: boolean;
}

const useSlider = ({
  isFullWidth,
  arrows,
  desktop,
  mobile,
  disableLazyLoad,
}: Isettings): { sliderSettings: any } => {
  const sliderSettings = useMemo(() => {
    return {
      //className: isFullWidth ? "full-width-carousel" : desktop?.class ?? "",
      dots: desktop?.dots ?? true,
      /*
      appendDots: (dots: any) => {
        dots = dots.map((dot: JSX.Element) => {
          // Makes dots not reachable with tab key
          const newDot = {
            ...dot,
            props: {
              ...dot.props,
              children: {
                ...dot.props.children,
                props: { ...dot.props.children.props},
              },
            },
          };
          return newDot;
        });
        return <MagicSliderDots dots={dots} numDotsToShow={5} dotWidth={22} />;
      },
      */
      infinite: true,
      speed: 500,
      // lazyLoad: disableLazyLoad ? undefined : ("progressive" as LazyLoadTypes),
      lazyLoad: true,
      slidesToShow: desktop?.slidesToShow ?? 3,
      slidesToScroll: desktop?.slidesToScroll ?? 1,
      //arrows: desktop?.arrows ?? true,
      variableWidth: desktop?.variableWidth ?? undefined,
      prevArrow: (
        <SlickArrow
          offset={arrows?.offset}
          color={arrows?.color}
          direction="prev"
        />
      ),
      nextArrow: (
        <SlickArrow
          slidesToShow={desktop?.slidesToShow ?? 3}
          slidesToScroll={desktop?.slidesToScroll ?? 1}
          offset={arrows?.offset}
          color={arrows?.color}
          direction="next"
        />
      ),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            className: isFullWidth
              ? "full-width-carousel"
              : mobile?.class ?? "",
            dots: mobile?.dots ?? false,
            arrows: mobile?.arrows ?? false,
            slidesToShow: mobile?.slidesToShow ?? 1,
            slidesToScroll: mobile?.slidesToScroll ?? 1,
            variableWidth: mobile?.variableWidth ?? undefined,
            lazyLoad: true,
            accessibility: true,
          },
        },
      ],
      accessibility: true,
    };
  }, [desktop, mobile, isFullWidth]);
  return { sliderSettings };
};

export default useSlider;
